// extracted by mini-css-extract-plugin
export default {"banner":"AdBanner_banner__1SUCp"};